export default __webpack_public_path__ + "static/img3-8f1369a8c66201b4732a774dc8ef933d.jpeg";